import Hammer from 'hammerjs';
import * as angular from 'angular';
import ngTranslate from 'angular-translate';
import ngTranslateStaticFiles from 'angular-translate-loader-static-files';
import qwDateModule from '@qwentes/angularjs-qw-date';
import qwZoomModule from '@qwentes/angularjs-qw-zoom';
import ngInfiniteScroll from 'ng-infinite-scroll';
import SidebarModule from './sidebar/sidebar.module';
import MenuModule from './menu/menu.module';
import ModalModule from './modal/modal.module';
import CarouselModule from './carousel/carousel.module';
import MediaQueryModule from './media-query/media-query.module';
import spinnerComponent from './spinner/spinner.component';
import relatedComponent from './related/related.component';
import RelatedModel from './related/related.model';
import itemComponent from './item/item.component';
import backComponent from './back/back.component';
import stripSpecialCharacters from './strip-special-characters/strip-special-characters.directive';
import userLoggedComponent from './user-logged/user-logged.component';
import coverImageDirective from './cover-image/cover-image.directive';
import breadcrumbComponent from './breadcrumb/breadcrumb.component';
import breadcrumbNavigationComponent from './breadcrumb/breadcrumb-navigation/breadcrumb-navigation.component';
import BreadcrumbService from './breadcrumb/breadcrumb.service';
import infiniteTrigger from './infinite-trigger/infinite-trigger.component';
import InfiniteTriggerService from './infinite-trigger/infinite-trigger.service';
import './button/button.scss';
import './input/input.scss';
import './icon/icon.scss';
import './wrapper/wrapper.scss';
import './section/section.scss';
import './select/select.scss';
import './empty/empty.scss';
import './switch/switch.scss';

export default angular
  .module('FHL.shared', [
    qwDateModule,
    qwZoomModule,
    ngInfiniteScroll,
    ngTranslate,
    SidebarModule,
    ModalModule,
    MenuModule,
    MediaQueryModule,
    CarouselModule,
  ])
  .directive('coverImage', coverImageDirective)
  .component('spinner', spinnerComponent)
  .component('related', relatedComponent)
  .component('item', itemComponent)
  .component('back', backComponent)
  .component('userLogged', userLoggedComponent)
  .component('infiniteTrigger', infiniteTrigger)
  .component('breadcrumb', breadcrumbComponent)
  .component('breadcrumbNavigation', breadcrumbNavigationComponent)
  .directive('stripSpecialCharacters', stripSpecialCharacters)
  .service('InfiniteTriggerService', InfiniteTriggerService)
  .service('BreadcrumbService', BreadcrumbService)
  .value('RelatedModel', RelatedModel)
  .name;



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.js